import uniq from "lodash/uniq";
import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { RowType } from "PFApp/booking/types";
import { EditMode } from "PFApp/booking/types/edit_mode";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { useBookingsForUpdate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update";
import { useBookingsForUpdateInvalidate } from "PFCore/hooks/queries/bookings/bulk_operation/use_bookings_for_update_invalidate";
import { useEffect } from "react";

import { useCalendarGridScope } from "../../parts/hooks";
import { usePastDatesStateContext } from "../../parts/overview/booking_module_calendar/booking_calendar/past_dates_context";
import { useBookingEditModeStoreActions, useEditMode } from "../booking_edit_mode_store";

export const useWallPlannerData = () => {
  const editMode = useEditMode();
  const { wallPlannerMode } = useBookingEditModeStoreActions();

  const calendarRoot = useCalendarRoot();
  const profileIds = useBookingModuleStore((state) =>
    state[calendarRoot].rows.filter(({ type }) => type === RowType.Profile).map(({ original }) => original.id)
  );

  const { invalidate } = useBookingsForUpdateInvalidate();
  const { pastFetchesCount } = usePastDatesStateContext();
  const dateRange = useCalendarGridScope({ pastFetchesCount });

  const enabled = editMode === EditMode.WallPlanner && isWorkforceProfiles(calendarRoot);

  const payload = {
    filters: [{ profileId: uniq(profileIds) }],
    dateRange,
    page: 1,
    perPage: PER_PAGE_UNPAGINATED
  };

  const { data: bookingsForUpdateData, isFetching } = useBookingsForUpdate("wall_planner", payload, {
    enabled: enabled
  });

  useEffect(() => {
    if (enabled && bookingsForUpdateData) {
      const updatableIds = bookingsForUpdateData.entries.map(({ id }) => id);
      wallPlannerMode.setUpdatableBookingIds(updatableIds);
    }
  }, [bookingsForUpdateData, wallPlannerMode, enabled]);

  useEffect(() => {
    wallPlannerMode.setIsLoading(isFetching);
  }, [isFetching, wallPlannerMode]);

  useEffect(() => {
    if (editMode !== EditMode.WallPlanner) {
      invalidate("wall_planner");
      wallPlannerMode.reset();
    }
  }, [editMode, invalidate, wallPlannerMode]);
};
